// extracted by mini-css-extract-plugin
export default {"container":"fIZuYaHf662KJXk8X531","secondary-text":"_vxmoXSdMKzMTAa9G04g","status-column":"X7ijOtrmrdta4zhIdOsw","pagination":"LstxzttO3tXKlVVtVeDF"};